import * as url from "helpers/url_helper/url_helper"
import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"

export const getPaymentMethodDef = () => get(url.GET_PAYMENT_METHOD_DEF)